module.exports = __webpack_public_path__ + "media/images/front/about/thumbnail-9ec450690f1433c97ac5e83992c63d4a.jpg";